import {DownloadSpeedMeter} from '../../../core/DownloadSpeedMeter';
import {Bitmovin8PlayerProxy} from '../Bitmovin8PlayerProxy';

import {BITMOVIN8_PLAYER_EVENT} from './Bitmovin8PlayerTypes';

export class SpeedMeterAdapter {
  private meter: DownloadSpeedMeter;

  constructor(player: Bitmovin8PlayerProxy, meter: DownloadSpeedMeter) {
    this.meter = meter;
    player.on(BITMOVIN8_PLAYER_EVENT.DownloadFinished, (event) => this.handleOnDownloadFinishEvent(event));
  }

  getDownloadSpeedMeter(): DownloadSpeedMeter {
    return this.meter;
  }

  handleOnDownloadFinishEvent(event: any) {
    if (!event.success) {
      return;
    }
    if (event.downloadType.indexOf('media/video') === 0) {
      this.meter.addMeasurement({
        duration: event.downloadTime,
        size: event.size,
        timeToFirstByte: event.timeToFirstByte,
        timestamp: new Date(),
        httpStatus: event.httpStatus,
      });
    }
  }
}
